import $ from "jquery";

const previousButton = document.getElementById("previous");
const firstnextButton = document.getElementsByClassName("firstnext");
const nextButton = document.getElementById("next");
const submitButton = document.getElementById('validate');
const form = document.getElementById('stepByStepForm');
const footerStartAgainBtn = document.getElementById('form-start-again');
const numberOfSteps = 10
var currentStep = 1

if ( $( ".calculator_retirement" ).length > 0) {

  previousButton.onclick = goPrevious
  nextButton.onclick = goNext
  footerStartAgainBtn.onclick = startToBegining

  for (var index = 0; index < firstnextButton.length; index++) {
    firstnextButton[index].addEventListener("click", goNext);
  }

}

function startToBegining(e)
  {
    e.preventDefault();
    currentStep = 1;
    hide(footerStartAgainBtn)
    goToStep(1);
  }

  function goNext(e) 
  {
    e.preventDefault()
    currentStep += 1
    goToStep(currentStep)
  }

  function goPrevious(e) {
    e.preventDefault()
    currentStep -= 1
    goToStep(currentStep)
  }

  function goToStep(stepNumber)
  {

    currentStep = stepNumber

    if (currentStep == 10) {
        calculateRetirement();
        show(footerStartAgainBtn);
    }
    
    let inputsToHide = document.getElementsByClassName('step')
    let inputs = document.getElementsByClassName(`step${currentStep}`)

    form.className = '';
    form.classList.add("form", "step-"+currentStep);
    
    //hide all input
    for (let i = 0; i < inputsToHide.length; ++i) {
        hide(inputsToHide[i])
    }
    
    //only show the right one
    for (let i = 0; i < inputs.length; ++i) {
        show(inputs[i])
    }
    
    //if we reached final step
    if(currentStep === numberOfSteps){
        enable(previousButton)
        disable(nextButton)
        show(submitButton)
    }
    
    //else if first step
    else if(currentStep === 1){
      disable(previousButton)
        enable(next)
        hide(submitButton)
    }
    
    else {
        enable(previousButton)
        enable(next)
        hide(submitButton)
    }
  }

  function enable(elem)
  {
    elem.classList.remove("disabled");
    elem.disabled = false;
  }

  function disable(elem)
  {
    elem.classList.add("disabled");
    elem.disabled = true;
  }

  function show(elem)
  {
    if (elem === null) {}
    else {
    elem.classList.remove('hidden');
    }
  }

  function hide(elem)
  {
    if (elem === null) {}
    else {
      elem.classList.add('hidden');
    }
  }

  function dropDownMenu()
  {
    const optionMenu = document.querySelector(".select-menu-3"),
      selectBtn = optionMenu.querySelector(".select-btn-3"),
      options = optionMenu.querySelectorAll(".option-3"),
      sBtn_text = optionMenu.querySelector(".sBtn-text-3");

    selectBtn.addEventListener("click", () =>
      optionMenu.classList.toggle("active")
    );

    options.forEach((option) => {

      if (option.classList.contains('active')) {
        sBtn_text.innerText = option.querySelector('.option-text-3').textContent;
      }

      option.addEventListener("click", (e) => {
        e.preventDefault();

        const repayentFrequency = e.currentTarget.getAttribute("data-value");
        $(".js-kiwisaver-percentage").val(parseInt(repayentFrequency));

        let selectedOption = option.querySelector(".option-text-3").innerText;
        sBtn_text.innerText = selectedOption;

        optionMenu.classList.remove("active")
        pay_off_more = void 0;

        // setTimeout((function() {
        //   return calculate()
        // }), 100);
      });
    });
  }

  function calculateRetirement() 
  {
    const currentAge = parseInt($(".js-age").val().replace(/,/g, ""));
    const retirementAge = parseInt($(".js-age-retire").val().replace(/,/g, ""));
    const lifeExpectancy = parseInt($(".js-age-plan-live").val().replace(/,/g, ""));
    const annualIncome = parseFloat($(".js-earn-per-year").val().replace(/,/g, ""));
    const retirementIncome = parseFloat($(".js-how-much-retirement").val().replace(/,/g, ""));
    let kiwisaverBalance = parseFloat($(".js-kiwi-saver-balance").val().replace(/,/g, ""));
    const kiwisaverContributionRate = parseInt($(".js-kiwisaver-percentage").val().replace(/,/g, ""))  / 100;
    let otherSavings = parseFloat($(".js-other-savings").val().replace(/,/g, ""));

    const employerContributionRate = 0.03; // 3%
    const kiwisaverReturnRate = 0.02; // 2%
    const otherSavingsReturnRate = 0.02; // 2%

    const yearsUntilRetirement = retirementAge - currentAge;
    const yearsInRetirement = lifeExpectancy - retirementAge;

    kiwisaverBalance = kiwisaverBalance * (1 + kiwisaverReturnRate) +
      (annualIncome * kiwisaverContributionRate * yearsUntilRetirement) +
      (annualIncome * employerContributionRate * yearsUntilRetirement * (1 + kiwisaverReturnRate));
  
    // Calculate other savings with return
    otherSavings = otherSavings * (1 + otherSavingsReturnRate);
    
    const totalSavingsAtRetirement = kiwisaverBalance + otherSavings;
    
      const annualIncomeInRetirement = retirementIncome * yearsInRetirement;
      const totalNeededForRetirement = annualIncomeInRetirement - totalSavingsAtRetirement;
      const weeklySavingsGoal = totalNeededForRetirement / (yearsUntilRetirement * 52);
    
  // console.log({
  //   currentAge: currentAge,
  //   retirementAge: retirementAge,
  //   lifeExpectancy: lifeExpectancy,
  //   annualSalary: annualSalary,
  //   desiredIncome: desiredIncome,
  //   kiwiSaverBalance: kiwiSaverBalance,
  //   kiwiSaverContribution: kiwiSaverContribution,

  //   yearsUntilRetirement: yearsUntilRetirement,
  //   yearsInRetirement: yearsInRetirement,
  //   annualSavingsRequired: annualSavingsRequired,
  //   weeklySavingsGoal: weeklySavingsGoal,
  //   weeklyKiwiSaverContributions: weeklyKiwiSaverContributions,
  //   totalSavingsGoal: totalSavingsGoal,
  // });

  var weeklySavingsGoal_int = parseInt(weeklySavingsGoal);
    // Display the results
    var formattedMoney = weeklySavingsGoal_int.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    console.log("formattedMoney : " + formattedMoney );

    document.getElementById('save-amount').textContent = `${formattedMoney.split('.')[0]}`;
  }

window.addEventListener('load', function(event) {

  if ( $( ".calculator_retirement" ).length > 0) {
    $(document).on("keyup", ".js-number-input-3", (function(e) {
      if ("" === window.getSelection().toString() && -1 === $.inArray(e.keyCode, [38, 40, 37, 39])) {
          var term,
            element = $(this), 
            value = element.val();
  
          element.hasClass("js-mortgage-interest-rate-2") || element.hasClass("js-loan-term-2") ? (term = value.replace(/[^0-9.]|\.(?=.*\.)/g, ""),
          element.hasClass("js-loan-term-2") && term > 30 && (term = 30)) : term = (term = value.replace(/[\D\s\._\-]+/g, "")) ? parseInt(term, 10) : 0,
          element.val((function() {
              return 0 === term ? 0 : term.toLocaleString("en-US")
          }))
      }
    }));
  
      dropDownMenu();
  }
   
});